import React, { useState, useEffect } from 'react';
import './BotonScroll.css';

const BotonScroll = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 15) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    showButton && (
      <button className="boton-scroll" onClick={scrollToTop}>
        <span className="arrow">↑</span>
      </button>
    )
  );
};

export default BotonScroll;
